/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

import '../../../styles/templates/account.scss';
import '../../../styles/templates/login.scss';
import $ from 'jquery';
import {FormInterceptor} from '../../ui/form-interceptor';
import {storageTracker} from '../../ui/utils/storage-tracker';

const namespace = 'password';

const selectors = {
  recoverForm: '#RecoverPassword',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink',
};

function checkUrlHash() {
  const hash = window.location.hash;

  if (hash !== '#recover') {
    return;
  }

  toggleRecoverForm();
}

/**
 * @param {Event} event
 */
function handleRecoverForm(event) {
  event.preventDefault();
  toggleRecoverForm();
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverForm() {
  $('.login-card').toggleClass('is-flipped');
  $('.login-card__face--front, .login-card__face--back').toggleClass(
    'is-hidden',
  );
}

/**
 *  Show reset password success message
 */
function resetSuccess() {
  const $formState = $('.reset-password-success');

  if (!$formState.length) {
    return;
  }

  $('#ResetSuccess').removeClass('hide');
}

if ($(selectors.recoverForm).length) {
  checkUrlHash();
  resetSuccess();

  $(selectors.recoverForm).on(`click.${namespace}`, handleRecoverForm);
  $(selectors.hideRecoverPasswordLink).on(
    `click.${namespace}`,
    handleRecoverForm,
  );
}

const $loginForm = $('#customer_login');
new FormInterceptor($loginForm, {
  type: 'login',
  storageTracker,
});
